import { GTM_EVENT } from '../../../../utilities/constants';

export function getCurrentLocation(path, isDaypass) {
  if (/\/?plan(?!\/confirmation)/.test(path)) return GTM_EVENT.PURCHASE_LOCATION.standard_purchase;
  if (/\/?\d+\/check-in/.test(path)) return GTM_EVENT.PURCHASE_LOCATION.pre_checkin;
  if ((/\/?my-reservations\/?/.test(path) && !isDaypass) || /\/?plan\/confirmation\/?/.test(path))
    return GTM_EVENT.PURCHASE_LOCATION.post_package_purchase;
  if (/\/?birthday-parties\/?/.test(path)) return GTM_EVENT.PURCHASE_LOCATION.standard_purchase;
  if ((/\/?my-reservations\/?/.test(path) && isDaypass) || /\/?daypass\/confirmation\/?/.test(path))
    return GTM_EVENT.PURCHASE_LOCATION.post_purchase_daypass;

  return null;
}
